var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-media-gallery" },
    _vm._l(_vm.product.media.slice(1, 2), function(media, index) {
      return _c(
        "div",
        { key: index, staticClass: "product-media-gallery__media-wrapper" },
        [
          _c("media", {
            staticClass: "product-media-gallery__media",
            attrs: {
              media: media,
              "aspect-ratio": _vm.aspectRatio,
              id: "gallery-media-" + index
            }
          })
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }